import './index.css';
import 'moment/locale/pt-br';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '@material-ui/core/Tooltip';
import MyCollapse from 'components/Collapse';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import ModalActions from 'components/ModalActions';
import PermissionHide from 'components/PermissionHide';
import Total from 'components/Total';
import { agent, API_MAP } from 'helpers';
import { constants } from 'helpers/constants';
import moment from 'moment';
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Alumy from 'scenes/Producer/Product/components/Partners/Alumy';
import { delivery, listInvoiceItems } from 'store/Orbita/Invoice/actions';
import InvoiceService from 'store/Orbita/Invoice/services';
import { newChargeInvoice } from 'store/Orbita/Subscriptions/actions';
import { PartialRefundRequestModal } from 'v2/components/Pages/Sales/PartialRefundRequestModal';
import InvoiceTags from 'v2/components/Shared/InvoiceTags';
import RefundInvoicePartnerButton from 'v2/components/Shared/RefundInvoicePartnerButton';
import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import { ruleRunner, run } from 'validations/ruleRunner';
import { isEmail, required } from 'validations/rules';

import type { ICanRefund } from 'v2/interfaces/shopping';

import styles from './styles';

import type { DispatchProp } from 'react-redux';

const fieldValidations = {
  newEmail: ruleRunner('newEmail', 'e-mail', required, isEmail),
};

interface IProps extends DispatchProp<any>, StyledComponentProps {
  email?: any;
  invoice_items: any;
  partialRefundInvoice: any;
  delivery: any;
  showRefund: boolean;
  user: any;
  charge: any;
  open: boolean;
  sale: any;
  filters: any;
  pagination: any;
  onClose: () => void;
  openDetailsTargetBlank?: boolean;
  isSubscription?: boolean;
}

interface IStates {
  tabValue: number;
  openModal: boolean;
  validationErrors: any;
  newEmail: string;
  emailChanged: string;
  openPartialRefundModal: boolean;
  partialRefundValue: string;
  disableButtonPartialRefund: boolean;
  partialRefundDescription: string;
  openModalNewCharge: boolean;
  downloadingReceipt: boolean;
  refund: ICanRefund | null;
}

class SalesQuickView extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      tabValue: 0,
      openModal: false,
      newEmail: '',
      emailChanged: '',
      validationErrors: {},
      openPartialRefundModal: false,
      downloadingReceipt: false,
      partialRefundValue: '0',
      disableButtonPartialRefund: false,
      partialRefundDescription: '',
      openModalNewCharge: false,
      refund: null,
    };
  }

  showChargeAgain = (sale: any): boolean => {
    if (!sale.contract_id) return false;

    if (!sale.payment_status || !sale.payment_method) return false;

    const allowedPaymentStatusToChargeAgain = [
      constants.PAYMENT_STATUS.OPEN,
      constants.PAYMENT_STATUS.EXPIRED,
      constants.PAYMENT_STATUS.WAITING_PAYMENT,
    ];

    if (!allowedPaymentStatusToChargeAgain.includes(Number(sale.payment_status.id))) return false;

    const disallowedPaymentMethodsToChargeAgain = [
      constants.PAYMENT_METHODS.BANKSLIP,
      constants.PAYMENT_METHODS.CREDIT_CARD_ELO,
      constants.PAYMENT_METHODS.DUPLICATED_CREDIT_CARD_ELO,
    ];

    if (disallowedPaymentMethodsToChargeAgain.includes(Number(sale.payment_method.id))) return false;

    return true;
  };

  canManualDeliver = (sale: any): boolean => {
    if (!sale.product) return false;

    if (sale.product.type === constants.JOBZZ) return false;

    const isProducer = !this.props.user.isFetching && sale.product.producer_id === this.props.user.id;

    if (!isProducer) return false;

    return true;
  };

  handleClickDownload = async () => {
    this.setState({ downloadingReceipt: true });
    const invoiceId = this.props.sale.id ? this.props.sale.id : this.props.sale.invoice_id;
    try {
      const response = await InvoiceService.downloadRefundReceipt(invoiceId);
      window.open(response.data.data[0].url, '_blank');
    } catch (err) {
      console.log(err);
    }

    this.setState({ downloadingReceipt: false });
  };

  copyValue = () => {};

  async componentDidUpdate(prevProps: any) {
    const nextProps = this.props;
    if (!prevProps.open && nextProps.open && nextProps.sale) {
      const invoiceId = nextProps.sale.id ? nextProps.sale.id : nextProps.sale.invoice_id;

      try {
        await this.props.dispatch(listInvoiceItems(invoiceId));
      } catch {
        toast.error('Ops, erro ao listar os itens da fatura');
      }

      agent.get(`${API_MAP.checkCanRefund}`.replace('{id}', invoiceId)).then((result) => {
        this.setState({ refund: result.data.data });
      });
    }
  }

  handleChangeTab = (event: any, value: number) => {
    this.setState({ tabValue: value });
  };

  onValidation = (field: string) => {
    let validationErrors = this.state.validationErrors;
    let obj = run(this.state, [fieldValidations[field]]);

    validationErrors[field] = obj[field];

    for (let prop in validationErrors) {
      if (!validationErrors[prop]) {
        delete validationErrors[prop];
      }
    }

    this.setState({
      validationErrors,
    });
  };

  handleChangeField = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.value;

    this.setState(newState, () => this.onValidation(name));
  };

  handleClickDelivery = () => {
    const { invoice_items, sale } = this.props;
    const invoiceId = sale.id ? sale.id : sale.invoice_id;
    (async () => {
      try {
        if (Alumy.isAlumy(sale.product.partner_id)) {
          invoice_items.forEach(async (item: { product_id: number }) => {
            await this.props.dispatch(Alumy.alumyProductDelivery(item.product_id, sale.student_customer.email));
          });
        } else {
          await this.props.dispatch(delivery(invoiceId));
        }

        toast.success('Sucesso, arquivo entregue com êxito');
      } catch (error: any) {
        if (typeof error === 'string') {
          toast.error(error);
          return;
        }
        toast.error('Ops, erro na entrega manual');
      }
    })();
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleClickEdit = () => {
    this.toggleModal();
  };

  toggleModal = () => {
    this.setState({
      openModal: !this.state.openModal,
    });
  };

  handleCloseModal = () => {
    this.setState({
      newEmail: '',
      validationErrors: {},
    });
    this.toggleModal();
  };

  openPartialRefundModal = () => {
    this.setState({
      openPartialRefundModal: !this.state.openPartialRefundModal,
    });
  };

  onChangeField = (value: any) => {
    let valueRefund = parseFloat(value);
    if (valueRefund < 0 && valueRefund > this.props.sale.sale_value) {
      this.setState({ partialRefundValue: '0' });
      return;
    }
    this.setState({ partialRefundValue: value });
  };
  newChargeInvoice = (subscriptionId: number, invoiceId: number) => {
    (async () => {
      try {
        await this.props.dispatch(newChargeInvoice(subscriptionId, invoiceId));
        toast.success('Uma nova tentativa de cobrança foi adicionada com sucesso.');
        this.setState({ openModalNewCharge: !this.state.openModalNewCharge });
      } catch {
        toast.error('Ops, houve um erro ao gerar uma nova cobrança.');
      }
    })();
  };

  shouldShowRecovery = (sale: any) => {
    const status = sale?.payment_status?.name || '';

    if (!sale?.checkout_recovery_link && !sale?.boleto_recovery_link) {
      return false;
    }

    if (status === 'Aberta' || status === 'Aguardando Pagamento' || status === 'Em Recuperacao') {
      return true;
    }

    return false;
  };

  newChargeConfirm = () => {
    this.setState({ openModalNewCharge: !this.state.openModalNewCharge });
  };

  handleCloseQuickview = () => {
    this.setState({
      refund: null,
    });
    this.props.onClose();
  };

  render() {
    const { refund } = this.state;

    this.props.open ? document.body.classList.add('no-scroll') : document.body.classList.remove('no-scroll');

    if (!this.props.open) {
      return <div className={'my-quickview'} />;
    }

    const sale = this.props.sale || {};
    const items = this.props.invoice_items || [];
    const invoiceId = this.props.sale.id ? this.props.sale.id : this.props.sale.invoice_id;
    const isSubscription = this.props.isSubscription ?? false;

    const canChargeAnotherUser = Boolean(localStorage.getItem('eadCharging'));

    const shouldShowPayerAndStudent = canChargeAnotherUser && sale?.student_customer?.id;
    const { classes, delivery, user } = this.props;
    const { downloadingReceipt } = this.state;

    const itemsArray = Array.isArray(items) ? items : [];
    const saleValue = sale?.sale_value || 0;
    const itemsValue = itemsArray.reduce((prev: any, cur: any) => prev + cur.amount, 0);
    const itemsSumValue = sale?.order_bump && itemsArray.length > 0 ? itemsValue : saleValue;
    const isLoading = !Array.isArray(items);
    const hideValuesAction = isSubscription ? 'myeduzz:meus-contratos:ocultar-valores' : 'myeduzz:minhas-vendas:ocultar-valores';
    const showCustomerDataAction = isSubscription ? 'myeduzz:meus-contratos:ver-dados-clientes' : 'myeduzz:minhas-vendas:ver-dados-clientes';

    return (
      <div>
        <div className='my-quickview -sales -active'>
          <div className='my-quickview__head'>
            <Grid container justify='space-between' alignItems='center'>
              <div className='my-quickview__title'>Fatura: {invoiceId}</div>

              <div className='my-quickview__close' onClick={this.handleCloseQuickview}>
                <Icon style={{ fontSize: '16x', color: '#ccc' }}>clear</Icon>
              </div>
            </Grid>
          </div>

          <div className='my-quickview__container'>
            <InvoiceTags size='small' invoice={sale} spacing={0} />
            <div className='m16' />
            <div className='card-container'>
              <a
                onClick={this.handleCloseQuickview}
                href={`/producer/invoice/details/${invoiceId}`}
                className='my-quickview__link'
                target='_blank'
                rel='noopener noreferrer'
              >
                Ver Detalhes <Icon>chevron_right</Icon>
              </a>

              <Tabs
                value={this.state.tabValue}
                onChange={this.handleChangeTab}
                indicatorColor='primary'
                textColor='primary'
                scrollButtons='off'
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
              >
                <Tab key='1' label='Fatura' disableRipple classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
                <Tab
                  key='2'
                  label={`Valores ${sale.currency ? sale.currency.currency_symbol : ''}`}
                  disableRipple
                  classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                />
              </Tabs>

              {this.state.tabValue === 0 && (
                <div className='my-list my-list--text -wtotal'>
                  <div className='my-list__table btransparent'>
                    <div className='my-list__container'>
                      <div className='my-list__row my-list__row--boxes -wmwidth'>
                        <div className='my-list__col'>
                          Código <span className='fw600'>{invoiceId}</span>
                        </div>
                        <div className='my-list__col'>
                          Status
                          <span title={sale.payment_status && sale.payment_status.name}>
                            {sale.payment_status && sale.payment_status.id !== 6 && sale.payment_status.id !== 15 && sale.payment_status.name}
                            {sale.payment_status && sale.payment_status.id === 6 && 'Ag. Reembolso'}
                            {sale.payment_status && sale.payment_status.id === 15 && 'Ag. Pagamento'}
                          </span>
                        </div>
                        <div className='my-list__col'>
                          {sale.created_at && (
                            <div className='my-list__col'>
                              Criação
                              <span>{moment(sale.created_at).format('L')}</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='my-list__row my-list__row--boxes -wmwidth'>
                        {sale.received_at && (
                          <div className='my-list__col'>
                            Pagamento
                            <span>{moment(sale.received_at).format('L')}</span>
                          </div>
                        )}
                        {sale.credited_at && (
                          <div className='my-list__col'>
                            Crédito
                            <span>{moment(sale.credited_at).format('L')}</span>
                          </div>
                        )}
                        {sale.expired_at && (
                          <div className='my-list__col'>
                            Vencimento
                            <span>{moment(sale.expired_at).format('L')}</span>
                          </div>
                        )}
                        {sale.payment_status && sale.payment_status.id === 7 && sale.refunded_at && (
                          <div className='my-list__col'>
                            Reembolso
                            <span>{moment(sale.refunded_at).format('L')}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {this.state.tabValue === 1 && (
                <div className='my-list my-list--text -wtotal'>
                  <div className='my-list__table btransparent'>
                    <div className='my-list__container'>
                      <div className='my-list__row my-list__row--boxes -wmwidth'>
                        <div className='my-list__col '>
                          Venda{' '}
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>{isLoading ? 'Carregando...' : <FormattedNumber value={itemsSumValue} format='BRL' />}</span>
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                        <div className='my-list__col '>
                          Taxa Eduzz{' '}
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>
                              <FormattedNumber value={sale.rate_amount} format='BRL' />
                            </span>{' '}
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                        <div className='my-list__col '>
                          Comissão{' '}
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>
                              <FormattedNumber value={sale.commission_amount} format='BRL' />
                            </span>{' '}
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                      </div>
                      <div className='my-list__row my-list__row--boxes -wmwidth'>
                        <div className='my-list__col '>
                          Parceiro{' '}
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>
                              <FormattedNumber value={sale.partner_amount} format='BRL' />
                            </span>{' '}
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                        <div className='my-list__col '>
                          Antecipação{' '}
                          <Tooltip
                            placement='top'
                            title='A antecipação é descontada diretamente no extrato financeiro (valor apenas para conhecimento)'
                          >
                            <Icon style={{ fontSize: 14, display: 'inline-block' }}>info</Icon>
                          </Tooltip>
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>
                              <FormattedNumber value={sale.anticipation_amount} format='BRL' />
                            </span>{' '}
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                        <div className='my-list__col '>
                          Outros{' '}
                          <PermissionHide inverse={1} action={hideValuesAction}>
                            <span className=''>
                              <FormattedNumber value={sale.others_values - Math.abs(sale.rate_amount_alumy)} format='BRL' />
                            </span>{' '}
                          </PermissionHide>
                          <PermissionHide inverse={false} action={hideValuesAction}>
                            <span>
                              <em>oculto</em>
                            </span>
                          </PermissionHide>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {sale.refund_values && sale.refund_values.type === 'parcial' && sale.refund_values.partial_value > 0 && (
                <div className={classes.total}>
                  Reembolso Parcial
                  <PermissionHide inverse={1} action={hideValuesAction}>
                    <span>
                      <ColoredFormattedNumber disableSymbol value={-sale.refund_values.partial_value} format={sale.currency && sale.currency.code} />
                      {sale.refund_values.status_partial_refund === 0 && (
                        <Tooltip placement='top' title='Reembolso em andamento'>
                          <Icon
                            className={'tred'}
                            style={{
                              fontSize: '16px',
                              verticalAlign: 'middle',
                              marginLeft: '0.2em',
                            }}
                          >
                            info
                          </Icon>
                        </Tooltip>
                      )}
                    </span>
                  </PermissionHide>
                  <PermissionHide inverse={false} action={hideValuesAction}>
                    <span>
                      <em>oculto</em>
                    </span>
                  </PermissionHide>
                </div>
              )}
              <div className='my-list__total'>
                Valor Líquido
                <PermissionHide inverse={1} action={hideValuesAction}>
                  <span>
                    {' '}
                    <ColoredFormattedNumber disableSymbol value={sale.net_income} format={sale.currency && sale.currency.code} />{' '}
                  </span>
                </PermissionHide>
                <PermissionHide inverse={false} action={hideValuesAction}>
                  <span>
                    <em>oculto</em>
                  </span>
                </PermissionHide>
              </div>
            </div>

            <div className='m32' />

            <PermissionHide action={showCustomerDataAction}>
              <div className={classes.customer}>
                {shouldShowPayerAndStudent && (
                  <div>
                    <span>Responsável Financeiro</span>
                  </div>
                )}

                {sale.customer && sale.customer.name && (
                  <div>
                    <span>Nome:</span> {sale.customer.name}
                  </div>
                )}
                {sale.customer && sale.customer.document_number && (
                  <div>
                    <span>CPF:</span> {sale.customer.document_number}
                  </div>
                )}
                {sale.customer && sale.customer.email && (
                  <div>
                    <span>E-mail:</span>

                    <PermissionHide action={['myeduzz:minhas-vendas:ver-dados-clientes', 'myeduzz:meus-contratos:ver-dados-clientes']}>
                      {this.state.emailChanged ? this.state.emailChanged : sale.customer.email ? sale.customer.email : 'Carregando...'}
                    </PermissionHide>
                    <PermissionHide inverse action={['myeduzz:minhas-vendas:ver-dados-clientes', 'myeduzz:meus-contratos:ver-dados-clientes']}>
                      oculto
                    </PermissionHide>
                  </div>
                )}
                {sale.customer && sale.customer.celphone && (
                  <div>
                    <span>Fone:</span> <WhatsAppLink phone={sale.customer.celphone} />
                  </div>
                )}

                {shouldShowPayerAndStudent && (
                  <React.Fragment>
                    <div className='m24' />

                    <div>
                      <span>Aluno</span>
                    </div>

                    {sale?.student_customer?.name && (
                      <div>
                        <span>Nome:</span> {sale.student_customer.name}
                      </div>
                    )}

                    {sale.student_customer?.email && (
                      <div>
                        <span>E-mail:</span> {sale.student_customer.email}
                      </div>
                    )}

                    {sale.student_customer?.celphone && (
                      <div>
                        <span>Fone:</span> <WhatsAppLink phone={sale.student_customer.celphone} />
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            </PermissionHide>

            <PermissionHide inverse action={showCustomerDataAction}>
              {!isSubscription && (
                <div className={classes.customer}>
                  {sale?.customer?.name && (
                    <div>
                      <span>Nome:</span> {sale.customer.name}
                    </div>
                  )}
                  <div>
                    <span>CPF:</span> <em>oculto</em>
                  </div>
                  <div>
                    <span>E-mail:</span> <em>oculto</em>
                  </div>
                  <div>
                    <span>Fone:</span> <em>oculto</em>
                  </div>
                </div>
              )}
            </PermissionHide>

            <div className='m24' />

            {this.props.open && (
              <MyCollapse title='Itens da Fatura' arrow noPadding>
                <div className='my-list my-list--numbers -wtotal'>
                  <div className='my-list__table'>
                    <div className='my-list__container'>
                      {items && items.isFetching ? (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <CircularProgress size={22} />
                        </div>
                      ) : items.length ? (
                        items.map((item: any) => (
                          <div key={'item-' + item.id} className='my-list__row'>
                            <div className='my-list__col col60'>{item.description}</div>

                            <div className='my-list__col col40 tright'>
                              <PermissionHide inverse={1} action={hideValuesAction}>
                                <FormattedNumber value={item.amount} format='BRL' />
                              </PermissionHide>
                              <PermissionHide inverse={false} action={hideValuesAction}>
                                <em>oculto</em>
                              </PermissionHide>
                            </div>
                          </div>
                        ))
                      ) : (
                        'Nenhum item encontrado...'
                      )}
                    </div>
                  </div>
                  <div className='my-list__total' style={{ padding: '0 1rem' }}>
                    Total{' '}
                    <span>
                      <PermissionHide inverse={1} action={hideValuesAction}>
                        <Total list={items} prop={'amount'} />
                      </PermissionHide>
                      <PermissionHide inverse={false} action={hideValuesAction}>
                        <em>oculto</em>
                      </PermissionHide>
                    </span>
                  </div>
                </div>
              </MyCollapse>
            )}

            {this.shouldShowRecovery(sale) ? (
              <React.Fragment>
                <div className='m8'></div>
                {this.props.open && (
                  <MyCollapse title='Recuperação' arrow>
                    <div className='my-invoice-details__links -recovery'>
                      <Grid container>
                        <>
                          <Grid item xs={12}>
                            <div className='my-invoice-details__copybox'>
                              <div className='my-title'>
                                <h3>Link para checkout</h3>
                              </div>

                              <CustomCopyToClipboard text={sale.checkout_recovery_link} fullWidth disableUnderline />
                            </div>
                          </Grid>

                          <div className='m16' />

                          <Grid item xs={12}>
                            <div className='my-invoice-details__copybox -last'>
                              <div className='my-title'>
                                <h3>Link para boleto</h3>
                              </div>

                              <CustomCopyToClipboard text={sale.boleto_recovery_link} fullWidth disableUnderline />
                            </div>
                          </Grid>
                        </>
                      </Grid>
                      <div className='m24' />
                    </div>
                  </MyCollapse>
                )}
              </React.Fragment>
            ) : (
              ''
            )}

            <div className='m24' />

            <div className='my-groupbutton'>
              <Grid container spacing={2}>
                {this.canManualDeliver(sale) && (
                  <Grid item xs={12}>
                    <PermissionHide action='myeduzz:minhas-vendas:entrega-manual'>
                      <Button
                        variant='outlined'
                        color='default'
                        onClick={this.handleClickDelivery}
                        disabled={delivery && delivery.isFetching}
                        fullWidth
                      >
                        Entrega Manual
                        {delivery && delivery.isFetching && (
                          <span style={{ marginLeft: 12, position: 'relative', top: 1 }}>
                            <CircularProgress size={16} style={{ color: '#596375' }} />
                          </span>
                        )}
                      </Button>
                    </PermissionHide>
                  </Grid>
                )}

                {this.props.showRefund && !!refund && (
                  <PermissionHide action='myeduzz:minhas-vendas:reembolsar'>
                    <RefundInvoicePartnerButton invoice={sale} refund={refund} />
                  </PermissionHide>
                )}

                {sale.payment_status && sale.payment_status.id === 7 && sale.refunded_at && sale.comission_type !== 'afiliado' && (
                  <Grid item xs={12}>
                    <PermissionHide action='myeduzz:minhas-vendas:reembolsar'>
                      <Button color='primary' variant='contained' onClick={this.handleClickDownload} disabled={downloadingReceipt} fullWidth>
                        Comprovante de Reembolso
                        {downloadingReceipt && (
                          <span style={{ marginLeft: 12, position: 'relative', top: 1 }}>
                            <CircularProgress size={16} style={{ color: '#fff' }} />
                          </span>
                        )}
                      </Button>
                    </PermissionHide>
                  </Grid>
                )}
                {!!refund && user.partial_refund && sale.product.type_id !== 3 && (
                  <PermissionHide action='myeduzz:minhas-vendas:reembolsar'>
                    <Tooltip title={refund?.can_refund_reason ?? ''} placement='top'>
                      <Grid item xs={12}>
                        <Button
                          color='default'
                          onClick={refund?.can_refund && this.openPartialRefundModal}
                          disabled={(delivery && delivery.isFetching) || !refund?.can_refund}
                          variant='outlined'
                          fullWidth
                        >
                          Reembolso Parcial
                          {delivery && delivery.isFetching && (
                            <span style={{ marginLeft: 12, position: 'relative', top: 1 }}>
                              <CircularProgress size={16} style={{ color: '#596375' }} />
                            </span>
                          )}
                        </Button>
                      </Grid>
                    </Tooltip>
                  </PermissionHide>
                )}
                {this.showChargeAgain(sale) && (
                  <Grid item xs={12}>
                    <Button color='default' variant='outlined' onClick={this.newChargeConfirm} fullWidth>
                      Cobrar Novamente
                    </Button>
                  </Grid>
                )}
              </Grid>
            </div>
          </div>
        </div>

        <PartialRefundRequestModal open={this.state.openPartialRefundModal} onClose={this.openPartialRefundModal} invoice={this.props.sale} />

        <ModalActions
          title='Deseja realmente cobrar novamente?'
          open={this.state.openModalNewCharge}
          onClose={this.newChargeConfirm}
          onOk={() => this.newChargeInvoice(sale.contract_id, invoiceId)}
          loading={this.props.charge.isFetching}
        >
          Este procedimento pode demorar alguns minutos.
        </ModalActions>

        <div className={this.props.open ? 'my-overlay -active' : 'my-overlay'} onClick={this.handleCloseQuickview} />
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    invoice_items: state.orbita.Invoice.items,
    partialRefundInvoice: state.orbita.Invoice.partialRefundInvoice,
    delivery: state.orbita.Invoice.delivery,
    user: state.orbita.User.user,
    charge: state.orbita.Subscriptions.charge,
    filters: state.components.MySales.filters,
    pagination: state.components.MySales.paginations,
  };
}
export default connect(mapStateToProps)(styles(SalesQuickView));
